import * as React from 'react';
import './App.css';
import { Portfolio } from './components/portfolio/Portfolio';
import { Navigation } from './components/nav/Nav';
import { Hero } from './components/hero/Hero';
import { About } from './components/about/About';
import { Clients } from "./components/clients/Clients";
import { Contact } from "./components/contact/Contact";
import { Footer } from "./components/footer/Footer";
import * as Scroll from 'react-scroll';

import 'animate.css/animate.css';
const { WOW } = require('wowjs');

type props = {};

class App extends React.Component<props, {}> {


  componentDidMount(): void {
    new WOW().init();

    Scroll.Events.scrollEvent.register('begin', function(to, element) {
      console.log("begin", arguments);
    });

    Scroll.Events.scrollEvent.register('end', function(to, element) {
      console.log("end", arguments);
    });

    Scroll.scrollSpy.update();
  }

  componentWillUnmount() {
    Scroll.Events.scrollEvent.remove('begin');
    Scroll.Events.scrollEvent.remove('end');
  }

  render() {
    return (
      <div>
        <Hero/>
        <About/>
        <Portfolio />
        <Clients/>
        <Contact/>
        <Footer/>
        <Navigation/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/App.tsx